import { ACCESS_TOKEN_STORAGE_KEY } from "@frontend-shared/constants";
import {
  EAnalyticsAuthMethod,
  EAnalyticsEvent,
} from "@frontend-shared/product-analytics";
import type { ISigninData } from "@frontend-shared/types";
import { useMutation } from "@tanstack/react-query";

import { authApi } from "@/api/services";
import { useAuth } from "@/hooks/use-auth";
import { useProductAnalytics } from "@/hooks/use-product-analytics";

export const useSignin = () => {
  const { getUser } = useAuth();
  const { capture } = useProductAnalytics();

  return useMutation({
    mutationFn: (params: ISigninData) => authApi.signin(params),
    onSuccess: (data) => {
      localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, data.accessToken);
      // NOTE: NSAI-4615 — the entry point of the activation funnel. Fired
      // before `getUser()` resolves, so it is still attributed to the
      // anonymous id and stitches onto the person once identify() lands.
      capture({
        event: EAnalyticsEvent.AUTH_LOGIN_COMPLETED,
        properties: { method: EAnalyticsAuthMethod.PASSWORD },
      });
      getUser();
    },
  });
};
